const Routes = {
  Login: '/login',
  Calculator: '/calculator',
  Simulator: '/simulation',
  Report: '/report',
  Home: '/',
  LeadForm: {
    Auto: '/auto/lead/step-1',
    Home: '/home/lead/step-1',
    HomeFinancing: '/home-financing/lead/step-1',
  },
  Leads: {
    Details: '/leads/:id',
  },
  DashboardAutonomous: '/dashboard',
  build: (path, variables = {}) =>
    Object.entries(variables).reduce(
      (route, [name, value]) => route.replace(`:${name}`, value),
      path,
    ),
}

export { Routes }
